import script from "./TermsPrivacyPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./TermsPrivacyPage.vue?vue&type=script&setup=true&lang=ts"

import "./TermsPrivacyPage.vue?vue&type=style&index=0&id=1f7319b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f7319b0"]])

export default __exports__